<template>
  <div></div>
</template>

<script>
import ApiClient from '@/components/api-client'

export default {
  name: 'logout',
  data () {
    return {}
  },
  created () {
    ApiClient.logout()
      .then(
        () => {
          this.$router.push({name: 'login'})
        })
  }
}
</script>

<style scoped lang="less">

</style>
